import { prefixKey } from '%app/js/common/services/storageService';

export const APPEARANCE_CHOICE_LIGHT = 'light';
export const APPEARANCE_CHOICE_DARK = 'dark';
export const APPEARANCE_CHOICE_HIGH_CONTRAST = 'high-contrast';
export const APPEARANCE_CHOICE_DEVICE = 'device';

export const APPEARANCE_CHOICES = [
    APPEARANCE_CHOICE_LIGHT,
    APPEARANCE_CHOICE_DARK,
    APPEARANCE_CHOICE_HIGH_CONTRAST,
    APPEARANCE_CHOICE_DEVICE,
];

export const DEFAULT_APPEARANCE_CHOICE = APPEARANCE_CHOICE_DEVICE;

export const SCHEME_LIGHT = 'light';
export const SCHEME_DARK = 'dark';
export const SCHEME_LIGHT_HIGH_CONTRAST = 'light-high-contrast';
export const SCHEME_DARK_HIGH_CONTRAST = 'dark-high-contrast';

export const APPEARANCE_SCHEMES = [
    SCHEME_LIGHT,
    SCHEME_DARK,
    SCHEME_LIGHT_HIGH_CONTRAST,
    SCHEME_DARK_HIGH_CONTRAST,
];

export const APPEARANCE_STORAGE_KEY = 'appearance';
export const APPEARANCE_STORED_KEY = prefixKey(APPEARANCE_STORAGE_KEY);
export const APPEARANCE_SCHEME_ATTRIBUTE = 'data-appearance';

export function isDarkScheme(scheme) {
    return scheme === SCHEME_DARK || scheme === SCHEME_DARK_HIGH_CONTRAST;
}

export function isHighContrastScheme(scheme) {
    return scheme === SCHEME_LIGHT_HIGH_CONTRAST || scheme === SCHEME_DARK_HIGH_CONTRAST;
}

export function normalizeAppearanceChoice(choice) {
    return APPEARANCE_CHOICES.includes(choice) ? choice : DEFAULT_APPEARANCE_CHOICE;
}
